<script>
export default {
  name: 'OrderBreakdown',
  props: {
    orderData: {
      type: Object,
    },
    equipmentType: {
      type: String,
    }
  },
  mounted() {
   }
}
</script>


<template>
  <v-card class="pa-2 cardWidth" dark color="transparent">
    <v-card-title>Order breakdown</v-card-title>
    <v-data-table :items="this.orderData.listOfOrderData" header-class="text-center" cell-class="text-center"
      :headers="this.orderData.orderDataTableHeaders" class="custom-table"
      v-if="this.orderData !== null">
      <template v-slot:item="{ item }">
        <tr @click="$emit('rowClicked', item)">
          <td>{{ item.Item_No }}</td>
          <td>{{ item.Order_No }}</td>
          <td>{{ item.Date_Formatted}}</td>
          <td>{{ item.Quantity }}</td>
          <td>{{ item.Scrap }}</td>
          <td>{{ item.Recut }}</td>
          <td>{{ item.SRF }}</td>
          <td v-if="equipmentType === 'Drill Pipe' || equipmentType === 'Heavy Weight'">
            {{ item.Hardbanding }}</td>

        </tr>

      </template>
    </v-data-table>

  </v-card>
</template>


<style scoped>
.text-center {
  text-align: start;
}
</style>